import React, { Fragment } from "react";

const DiscussionParticipantItem = ({
  participant,
  removeParticipant,
  setParticipant,
}) => {
  return (
    <Fragment>
      <div className="single-user">
        <div className="outside-container">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${participant.avatar}`}
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">
                    {participant.channelid}
                  </span>
                </li>
                <li class="side-container-user-item">
                  {participant.firstname} {participant.lastname}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="user-buttons">
          <button
            onClick={() => {
              setParticipant({
                channelid: participant.channelid,
                avatar: participant.avatar,
                firstname: participant.firstname,
                lastname: participant.lastname,
              });
              removeParticipant(participant.channelid);
            }}
            className="user-button background-red"
          >
            <i className="far fa-times-circle mx-5"></i>Remove
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionParticipantItem;
